module.exports = __webpack_public_path__ + "img/xinzhuang-3.484f9c38.jpg";